import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { TestimonialDTO } from './types';

export const useGetTestimonialById = (id?: string, enabled = true) => {
	return useQuery<TestimonialDTO>({
		queryKey: ['testimonial', id],
		queryFn: async () => {
			const { data } = await api.get<TestimonialDTO>(`/management/testimonial/get/${id}`);
			return data;
		},
		enabled: !!id && enabled,
	});
};
